/* Exoshave One-Page theme */
(function () {
  'use strict';
  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var EXO = window.exo || {};
  var JSON_HEADERS = { 'Content-Type': 'application/json', Accept: 'application/json' };

  /* ---------- money ---------- */
  function makeMoney(sample, currency, locale) {
    sample = String(sample || '').replace(/&nbsp;/g, ' ');
    var m = sample.match(/1([.,'\s  ]?)234(?:([.,])56)?/);
    var nf;
    try { nf = new Intl.NumberFormat(locale || undefined, { style: 'currency', currency: currency || 'USD' }); }
    catch (e) { nf = new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD' }); }
    return function (cents) {
      cents = Math.round(cents);
      if (!m) return nf.format(cents / 100);
      var whole = Math.floor(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, m[1]);
      var num = m[2] ? whole + m[2] + ('0' + (cents % 100)).slice(-2) : whole;
      return sample.slice(0, m.index) + num + sample.slice(m.index + m[0].length);
    };
  }

  /* Shopify's | t escapes HTML (' → &#39;) — decode so textContent shows real characters */
  var decodeT = function (obj) {
    var ta = document.createElement('textarea');
    Object.keys(obj).forEach(function (k) { if (typeof obj[k] === 'string' && obj[k].indexOf('&') > -1) { ta.innerHTML = obj[k]; obj[k] = ta.value; } });
    return obj;
  };
  var fill = function (str, vars) {
    str = str || '';
    Object.keys(vars || {}).forEach(function (k) { str = str.split('%' + k + '%').join(vars[k]); });
    return str;
  };

  /* ---------- countdown (evergreen, per session) ---------- */
  $$('[data-countdown]').forEach(function (el) {
    var mins = parseInt(el.getAttribute('data-countdown'), 10) || 17;
    var end;
    try { end = parseInt(sessionStorage.getItem('exo_cd_end'), 10); } catch (e) {}
    var now = Date.now();
    if (!end || end < now) { end = now + mins * 60000; try { sessionStorage.setItem('exo_cd_end', String(end)); } catch (e) {} }
    var mEl = $('[data-cd-min]', el), sEl = $('[data-cd-sec]', el);
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var left = Math.max(0, Math.round((end - Date.now()) / 1000));
      mEl.textContent = pad(Math.floor(left / 60)); sEl.textContent = pad(left % 60);
      if (!left) { clearInterval(iv); try { sessionStorage.removeItem('exo_cd_end'); } catch (e) {} }
    };
    var iv = setInterval(tick, 1000); tick();
  });

  /* ---------- mobile menu ---------- */
  var drawer = $('[data-menu]');
  if (drawer) {
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { drawer.hidden = false; document.body.style.overflow = 'hidden'; }); });
    var close = function () { drawer.hidden = true; document.body.style.overflow = ''; };
    $$('[data-menu-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    drawer.addEventListener('click', function (e) { if (e.target === drawer) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !drawer.hidden) close(); });
  }

  /* ---------- smooth scroll to buy box ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href="#buy"]');
    if (!a) return;
    var buy = document.getElementById('buy');
    if (!buy) return;
    e.preventDefault();
    buy.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- qty steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qty-minus],[data-qty-plus]');
    if (!btn) return;
    var input = $('[data-qty-input]', btn.parentNode);
    if (!input) return;
    var min = parseInt(input.min || '0', 10);
    var v = (parseInt(input.value, 10) || 0) + (btn.hasAttribute('data-qty-plus') ? 1 : -1);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  $$('[data-autosubmit]').forEach(function (input) {
    var t;
    input.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () { input.form.submit(); }, 450);
    });
  });

  /* ---------- galleries ---------- */
  $$('[data-gallery]').forEach(function (gal) {
    var track = $('[data-track]', gal);
    var thumbs = $$('[data-thumb]', gal);
    if (!track) return;
    /* RTL (Hebrew): scrollLeft runs 0 -> negative and slides flow right-to-left, so work with |scrollLeft| and a sign. */
    var rtl = function () { return getComputedStyle(track).direction === 'rtl'; };
    var idx = function () { return Math.round(Math.abs(track.scrollLeft) / Math.max(1, track.clientWidth)); };
    var go = function (i) {
      var n = track.children.length; if (!n) return;
      i = (i + n) % n;
      track.scrollTo({ left: (rtl() ? -1 : 1) * track.clientWidth * i, behavior: 'smooth' });
    };
    gal.exoGoToMedia = function (mediaId) {
      var slides = Array.prototype.slice.call(track.children);
      for (var i = 0; i < slides.length; i++) if (slides[i].getAttribute('data-media-id') === String(mediaId)) { go(i); return; }
    };
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(parseInt(b.getAttribute('data-thumb'), 10)); }); });
    var prev = $('[data-prev]', gal), next = $('[data-next]', gal);
    /* the left-hand button always moves the strip towards the left, whatever the writing direction */
    if (prev) prev.addEventListener('click', function () { go(idx() + (rtl() ? 1 : -1)); });
    if (next) next.addEventListener('click', function () { go(idx() + (rtl() ? -1 : 1)); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = idx();
        thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === i); });
      });
    }, { passive: true });
  });

  /* ---------- header cart count ---------- */
  function refreshCount() {
    fetch((EXO.routes && EXO.routes.cart || '/cart') + '.js', { headers: JSON_HEADERS })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; }); })
      .catch(function () {});
  }

  /* ---------- Exoshave buy box (subscription-first) ---------- */
  var form = $('[data-buy-form]');
  if (form) (function () {
    var d = form.dataset;
    var fmt = makeMoney(d.moneySample || EXO.moneySample, d.currency || EXO.currency, d.locale);
    var T = {};
    try { T = JSON.parse(($('[data-i18n]', form) || {}).textContent || '{}'); } catch (e) {}
    decodeT(T);
    var hasPlan = d.hasPlan === 'true', deviceMode = d.deviceMode === 'true', firstFree = d.firstFree === 'true';
    var pct = parseFloat(d.subDiscount || '0') || 0;
    var planId = Number(d.plan) || 0, planPrice = parseInt(d.planPrice || '0', 10), planRecurring = parseInt(d.planRecurring || d.planPrice || '0', 10);
    var subQty = parseInt(d.subQty || '2', 10), subWeeks = d.subWeeks || '';
    var bladeVariant = Number(d.bladeVariant), onceBladeVariant = Number(d.onceBladeVariant) || Number(d.bladeVariant);
    var bladePrice = parseInt(d.bladePrice || '0', 10);          // list price in the visitor's currency
    var bladeList = parseInt(d.bladeList || '3195', 10);         // list price in the shop currency (for the $-off tiers)
    // one-time bundle tiers "3:700,6:1000,9:1146" = units : cents off each (shop currency) → applied as a % of the local price
    var onceTiers = (d.onceTiers || '').split(',').map(function (s) {
      var p = s.split(':'); var units = parseInt(p[0], 10), off = parseInt(p[1], 10) || 0;
      return units ? { units: units, each: Math.round(bladePrice * (1 - off / bladeList)) } : null;
    }).filter(Boolean);
    var tiers = $$('[data-tier]', form);
    var oncePanel = $('[data-once-panel]', form), onceLink = $('[data-once-link]', form), benefits = $('[data-benefits]', form);
    var onceOn = $('[data-once-on]', form), onceControls = $('[data-once-controls]', form), onceQty = $('[data-once-qty]', form), onceBox = $('[data-once-box]', form);
    var subOn = $('[data-sub-on]', form), subBox = $('[data-sub-box]', form);
    var extras = $$('[data-extra]', form);
    var gallery = document.querySelector('.buy-sec [data-gallery]');
    var mode = hasPlan ? 'sub' : 'none'; // 'sub' | 'once'

    if (onceQty) onceTiers.forEach(function (t, i) {
      var o = document.createElement('option'); o.value = t.units; o.textContent = fill(T.once_option, { n: t.units, each: fmt(t.each) });
      if (i === 0) o.selected = true; onceQty.appendChild(o);
    });

    var subPrice = function (cents) { return cents - Math.round(cents * pct / 100); };
    var tierSubPrice = function (t) { return t.dataset.subPrice ? parseInt(t.dataset.subPrice, 10) : subPrice(parseInt(t.dataset.price, 10)); };
    var tierVariant = function (t, sub) { return Number(sub && t.dataset.subVariant ? t.dataset.subVariant : t.dataset.variant); };
    var currentTier = function () { return tiers.filter(function (t) { return $('input', t).checked; })[0] || tiers[0]; };
    var subActive = function () { return hasPlan && (mode === 'sub' || (subOn && subOn.checked)); };
    var onceActive = function () { return !subActive() && !!(onceOn && onceOn.checked); };
    var onceTier = function () { var u = onceQty ? parseInt(onceQty.value, 10) : 0; return onceTiers.filter(function (t) { return t.units === u; })[0] || onceTiers[0]; };

    function cartItems() {
      var t = currentTier();
      var sub = subActive();
      var items = [{ id: tierVariant(t, sub), quantity: 1 }];
      if (sub && deviceMode && t.dataset.subPlan) items[0].selling_plan = Number(t.dataset.subPlan); // shaver on the plan; Recharge swaps it to blades
      else if (sub) items.push({ id: bladeVariant, quantity: subQty, selling_plan: planId });
      else if (onceActive()) items.push({ id: onceBladeVariant, quantity: onceTier().units });
      extras.forEach(function (x) { if ($('input', x).checked) items.push({ id: Number(x.dataset.variant), quantity: 1 }); });
      return items;
    }

    function render() {
      var sub = subActive();
      if (oncePanel) oncePanel.hidden = mode !== 'once';
      if (onceLink) onceLink.hidden = mode === 'once';
      if (benefits) benefits.hidden = mode === 'once';
      if (onceBox) onceBox.classList.toggle('is-on', onceActive());
      if (onceControls) onceControls.hidden = !onceActive();
      if (subBox) subBox.classList.toggle('is-on', sub);
      tiers.forEach(function (t) {
        var price = parseInt(t.dataset.price, 10), cmp = parseInt(t.dataset.compare, 10) || price;
        var now = sub ? tierSubPrice(t) : price, was = Math.max(cmp, price);
        $('[data-now]', t).textContent = fmt(now);
        $('[data-was]', t).textContent = was > now ? fmt(was) : '';
        t.classList.toggle('is-selected', $('input', t).checked);
      });
      var t = currentTier();
      var devPrice = parseInt(t.dataset.price, 10);
      var devCmp = Math.max(parseInt(t.dataset.compare, 10) || devPrice, devPrice);
      var devToday = sub ? tierSubPrice(t) : devPrice;
      var bladesToday = 0, bladesWas = 0, renew = T.one_time_only;
      if (sub) {
        var firstToday = (deviceMode || firstFree) ? 0 : planPrice;
        bladesToday = firstToday * subQty; bladesWas = deviceMode ? 0 : bladePrice * subQty;
        renew = fill(T.renew_sub, { count: subQty, each: fmt(planRecurring || bladePrice), amount: fmt((planRecurring || bladePrice) * subQty), weeks: subWeeks });
        if (firstFree && T.first_free) renew = fill(T.first_free, { count: subQty, weeks: subWeeks, zero: fmt(0) }) + ' ' + renew;
        if (T.sub_club) renew = fill(T.sub_club, { count: subQty, weeks: subWeeks, each: fmt(planRecurring || bladePrice) });
      } else if (onceActive()) {
        var ot = onceTier();
        bladesToday = ot.each * ot.units; bladesWas = bladePrice * ot.units;
        $('[data-once-line]', form).textContent = fill(T.once_line, { count: ot.units, each: fmt(ot.each), total: fmt(bladesToday) });
      }
      var extrasToday = 0;
      extras.forEach(function (x) { x.classList.toggle('is-on', $('input', x).checked); if ($('input', x).checked) extrasToday += parseInt(x.dataset.price, 10); });
      var today = devToday + bladesToday + extrasToday, was = devCmp + bladesWas + extrasToday;
      $('[data-sum-total]', form).textContent = fmt(today);
      $('[data-sum-was]', form).textContent = was > today ? fmt(was) : '';
      $('[data-sum-save]', form).textContent = was > today ? fill(T.you_save, { amount: fmt(was - today) }) : '';
      $('[data-renew]', form).textContent = renew;
      var sName = $('[data-sticky-name]'), sTotal = $('[data-sticky-total]');
      if (sName) sName.textContent = $('.bb-tier-name', t).textContent;
      if (sTotal) sTotal.textContent = fmt(today);
    }

    tiers.forEach(function (t) {
      $('input', t).addEventListener('change', function () {
        render();
        if (gallery && gallery.exoGoToMedia && t.dataset.media) gallery.exoGoToMedia(t.dataset.media);
      });
    });
    if (onceLink) onceLink.addEventListener('click', function () {
      mode = 'once';
      if (subOn) subOn.checked = false;
      if (onceOn) onceOn.checked = true;
      render();
    });
    if (subOn) subOn.addEventListener('change', function () {
      if (subOn.checked) { mode = 'sub'; if (onceOn) onceOn.checked = false; }
      render();
    });
    if (onceOn) onceOn.addEventListener('change', function () {
      if (onceOn.checked && subOn) subOn.checked = false;
      render();
    });
    if (onceQty) onceQty.addEventListener('change', render);
    extras.forEach(function (x) { $('input', x).addEventListener('change', render); });

    var atc = $('[data-atc]', form), err = $('[data-error]', form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      atc.classList.add('is-loading'); atc.disabled = true; if (err) err.hidden = true;
      // Replace any earlier shaver/blade/add-on lines (back-button re-adds) so the order is exactly what's selected
      var ours = {};
      tiers.forEach(function (t) { ours[t.dataset.variant] = 1; if (t.dataset.subVariant) ours[t.dataset.subVariant] = 1; });
      ours[String(bladeVariant)] = 1; ours[String(onceBladeVariant)] = 1;
      extras.forEach(function (x) { ours[x.dataset.variant] = 1; });
      var cartUrl = (EXO.routes && EXO.routes.cart) || '/cart';
      fetch(cartUrl + '.js', { headers: JSON_HEADERS, credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          var updates = {}, any = false;
          (c.items || []).forEach(function (it) { if (ours[String(it.variant_id)]) { updates[it.key] = 0; any = true; } });
          if (!any) return null;
          return fetch(cartUrl + '/update.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ updates: updates }) });
        })
        .catch(function () { return null; })
        .then(function () {
          return fetch((EXO.routes && EXO.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: cartItems() }) });
        })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          try { if (window.fbq) fbq('track', 'AddToCart'); } catch (x) {}
          window.location.href = '/checkout';
        })
        .catch(function () {
          atc.classList.remove('is-loading'); atc.disabled = false; if (err) err.hidden = false;
        });
    });

    // sticky mobile bar
    var sticky = $('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0;
      }).observe(atc);
    }
    render();
  })();

  /* ---------- replacement-blade buy box (aligned with the shaver page) ---------- */
  var bform = $('[data-blade-box]');
  if (bform) (function () {
    var d = bform.dataset;
    var fmt = makeMoney(d.moneySample || EXO.moneySample, d.currency || EXO.currency, d.locale);
    var T = {};
    try { T = JSON.parse(($('[data-i18n]', bform) || {}).textContent || '{}'); } catch (e) {}
    decodeT(T);
    var hasSub = d.hasSub === 'true', planId = Number(d.plan) || 0, planPrice = parseInt(d.planPrice || '0', 10);
    var subQty = parseInt(d.subQty || '2', 10), subWeeks = d.subWeeks || '';
    var variant = Number(d.variant), price = parseInt(d.price || '0', 10), listCents = parseInt(d.bladeList || '3195', 10);
    var tiers = (d.onceTiers || '').split(',').map(function (s) {
      var p = s.split(':'); var units = parseInt(p[0], 10), off = parseInt(p[1], 10) || 0;
      return units ? { units: units, each: Math.round(price * (1 - off / listCents)) } : null;
    }).filter(Boolean);
    var modes = $$('[data-mode]', bform), sizesWrap = $('[data-sizes-wrap]', bform), sizesBox = $('[data-sizes]', bform);
    var atc = $('[data-atc]', bform), err = $('[data-error]', bform);
    // build size cards
    tiers.forEach(function (t, i) {
      var l = document.createElement('label'); l.className = 'blade-size'; l.dataset.size = t.units;
      l.innerHTML = '<input type="radio" name="blade-units" value="' + t.units + '"' + (i === 0 ? ' checked' : '') + '>' +
        (i === 1 ? '<span class="bb-badge">★ ' + (T.popular || '') + '</span>' : '') +
        '<span class="blade-size-n">' + fill(T.many, { n: t.units }) + '</span><span class="blade-size-p">' + fmt(t.each) + T.each + '</span><span class="blade-size-c">' + (t.each < price ? fmt(price) + T.each : '') + '</span>';
      sizesBox.appendChild(l);
    });
    var sizes = $$('[data-size]', bform);
    var mode = function () { var m = modes.filter(function (l) { return $('input', l).checked; })[0]; return (m && hasSub) ? m.dataset.mode : 'once'; };
    var tier = function () { var u = parseInt((sizes.filter(function (l) { return $('input', l).checked; })[0] || sizes[0]).dataset.size, 10); return tiers.filter(function (t) { return t.units === u; })[0] || tiers[0]; };
    function render() {
      var sub = mode() === 'sub', t = tier();
      modes.forEach(function (l) {
        var mm = l.dataset.mode, p = mm === 'sub' ? planPrice * subQty : (t ? t.each * t.units : 0);
        var el = $('[data-mode-price="' + mm + '"]', l); if (el) el.textContent = p ? fmt(p) : '';
        l.classList.toggle('is-selected', mm === (sub ? 'sub' : 'once'));
      });
      sizes.forEach(function (l) { l.classList.toggle('is-checked', $('input', l).checked); });
      if (sizesWrap) sizesWrap.hidden = sub;
      var pill = $('[data-sub-pill]', bform);
      if (pill) { var pct = price ? Math.round((1 - planPrice / price) * 100) : 0; pill.textContent = pct > 0 ? fill(T.save_pill, { n: pct }) : ''; pill.hidden = !pct; }
      var total = sub ? planPrice * subQty : (t ? t.each * t.units : 0);
      var list = price * (sub ? subQty : (t ? t.units : 0));
      $('[data-sum-total]', bform).textContent = fmt(total);
      $('[data-sum-was]', bform).textContent = list > total + 1 ? fmt(list) : '';
      $('[data-sum-save]', bform).textContent = list > total + 1 ? fill(T.you_save, { amount: fmt(list - total) }) : '';
      $('[data-renew]', bform).textContent = sub ? fill(T.renew, { count: subQty, amount: fmt(total), weeks: subWeeks }) : T.once_only;
    }
    modes.forEach(function (l) { $('input', l).addEventListener('change', render); });
    sizes.forEach(function (l) { $('input', l).addEventListener('change', render); });
    bform.addEventListener('submit', function (e) {
      e.preventDefault();
      if (d.available !== 'true') return;
      var sub = mode() === 'sub', t = tier();
      var item = sub ? { id: variant, quantity: subQty, selling_plan: planId } : { id: variant, quantity: t.units };
      if (err) err.hidden = true;
      atc.classList.add('is-loading'); atc.disabled = true;
      fetch((EXO.routes && EXO.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: JSON_HEADERS, body: JSON.stringify({ items: [item] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () { try { if (window.fbq) fbq('track', 'AddToCart'); } catch (x) {} window.location.href = '/checkout'; })
        .catch(function () { atc.classList.remove('is-loading'); atc.disabled = false; if (err) err.hidden = false; });
    });
    render();
  })();

  /* ---------- generic product form ---------- */
  var pform = document.getElementById('pdp-form');
  if (pform) (function () {
    var vSelect = $('[data-variant-select]', pform);
    var optSelects = $$('[data-option-index]', pform);
    var priceBox = $('[data-pdp-price]');
    var atc = $('[data-pdp-atc]', pform), err = $('[data-error]', pform);
    var atcLabel = atc ? atc.innerHTML : '';
    function sync() {
      if (!optSelects.length) return;
      var want = optSelects.map(function (s) { return s.value; }).join('||');
      var opt = $$('option', vSelect).filter(function (o) { return o.dataset.options === want; })[0];
      if (!opt) { if (atc) atc.disabled = true; return; }
      vSelect.value = opt.value;
      if (priceBox) priceBox.innerHTML = '<span class="price' + (opt.dataset.compare ? ' price--sale' : '') + '">' + (opt.dataset.compare ? '<s class="price-was">' + opt.dataset.compare + '</s> ' : '') + '<span class="price-now">' + opt.dataset.price + '</span></span>';
      if (atc) atc.disabled = opt.dataset.available !== 'true';
      try { var u = new URL(location.href); u.searchParams.set('variant', opt.value); history.replaceState(null, '', u); } catch (e) {}
    }
    optSelects.forEach(function (s) { s.addEventListener('change', sync); });
    pform.addEventListener('submit', function (e) {
      e.preventDefault();
      if (atc) { atc.disabled = true; atc.classList.add('is-loading'); }
      if (err) err.hidden = true;
      var fd = new FormData(pform);
      if (!fd.get('selling_plan')) fd.delete('selling_plan');
      fetch((EXO.routes && EXO.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          refreshCount();
          window.location.href = (EXO.routes && EXO.routes.cart) || '/cart';
        })
        .catch(function () {
          if (atc) { atc.disabled = false; atc.classList.remove('is-loading'); atc.innerHTML = atcLabel; }
          if (err) err.hidden = false;
        });
    });
  })();


  /* ---------- cart: keep subscriber-price shaver and its blade plan together ---------- */
  (function () {
    var g = document.querySelector('[data-sub-guard]');
    if (!g) return;
    var subs = parseInt(g.dataset.subCount || '0', 10), plans = parseInt(g.dataset.planCount || '0', 10);
    var pv = Number(g.dataset.planVariant), pid = Number(g.dataset.planId), pq = parseInt(g.dataset.planQty || '2', 10);
    var H = { 'Content-Type': 'application/json', Accept: 'application/json' };
    var busy = function () { g.style.opacity = '.5'; g.style.pointerEvents = 'none'; };
    if (subs > 0 && plans === 0 && pv && pid) {
      busy();
      fetch('/cart/add.js', { method: 'POST', headers: H, body: JSON.stringify({ items: [{ id: pv, quantity: pq, selling_plan: pid }] }) })
        .then(function () { location.reload(); }, function () { location.reload(); });
    } else if (subs === 0 && plans > 0) {
      var up = {};
      Array.prototype.forEach.call(g.querySelectorAll('[data-plan-line]'), function (el) { up[el.dataset.lineKey] = 0; });
      busy();
      fetch('/cart/update.js', { method: 'POST', headers: H, body: JSON.stringify({ updates: up }) })
        .then(function () { location.reload(); }, function () { location.reload(); });
    }
  })();

  /* ---------- login: recover toggle ---------- */
  var recover = document.getElementById('recover'), login = document.getElementById('login');
  if (recover && login) {
    var show = function () { var r = location.hash === '#recover'; recover.hidden = !r; login.hidden = r; };
    window.addEventListener('hashchange', show); show();
  }
  $$('select[data-default]').forEach(function (s) { if (s.dataset.default) s.value = s.dataset.default; });
})();
